import { InitClaro } from "./Videos/CLARO_01/initClaro";

export const MyComposition: React.FC = () => {
	const propData = {
		videoFolder: "CLARO_01",
		name: "Nombre de ejemplo",
		seccion1: {
			title: "Hola",
			name: "",
			text: "Te tenemos una gran noticia"
		},
		seccion2: {
			cuotasText: "# de cuotas",
			cuotasPosicion: 12,
			cuotasSteps: [6, 12, 18, 24],
			title: "Tu plan de pagos del equipo",
			subtitle: "iPhone XS Max 256 GB",
			text: "finaliza en",
			month: "septiembre",
		},
		seccion3: {
			title: "iPhone 16 Pro",
			especificaciones: [
				{ icono: "03_ICON_1.svg", text: "Velocidad de internet más rápida" },
				{ icono: "03_ICON_2.svg", text: "El procesador más potente creado por Apple" },
				{ icono: "03_ICON_3.svg", text: "Pantalla OLED ProMotion" },
				{ icono: "03_ICON_4.svg", text: "Triple Cámara" },
				{ icono: "03_ICON_5.svg", text: "Convectividad 5G Mejorada" },
				{ icono: "03_ICON_6.svg", text: "USB-C" },
			],
			text: "¡Y mucho más!"
		},
		seccion4: {
			title: "Pantalla OLED de ProMotion",
			text: "La espectacular pantalla OLED de 6.4 pulgadas en el iPhone 16 Pro ofrece una claridad y un color incomparables."
		},
		seccion5: {
			title: "Triple Cámara",
			text: "La cámara principal de 48 MP, junto con un ultra gran angular y un tele-objetivo, te permiten tomar fotos y videos con una claridad impresionante, incluso en condiciones de poca luz."
		},
		seccion6: {
			title: "Conectividad 5G Mejorada",
			text: "Disfruta de descargas ultrarrápidas, streaming sin interrupciones y una navegación web instantánea, sin importar dónde te encuentres."
		},
		seccion7: {
			title: "Seguridad y Privacidad Avanzadas",
			text: "Apple sigue siendo líder en privacidad con el iPhone 16 Pro, gracias a su sistema operativo iOS 18. Con Face ID mejorado y opciones avanzadas de control de privacidad,puedes estar seguro de que tu información personal está siempre protegida."
		},
		seccion8: {
			text1: "",
			text2: "Esta oferta es solo para ti",
			text3: "Conoce más",
			linkText: "AQUÍ",
			linkUrl: "#"
		},
		seccion9: {
			plan: [
				{ label: "Cuota mensual", value: "$100.000" },
				{ label: "Plazo", value: "24 Meses" },
				{ label: "Más beneficios", value: "Precio especial" }
			]
		},
		seccion10: {
			buttonText: "QUIERO EL NUEVO PLAN",
			buttonLink: "#",
			title: "¡No lo dejes pasar!",
			text: "Notificación",
			textAlt: "Ahora"
		},
		seccion11: {
			name: "",
			title: "Gracias por confiar en nosotros",
			text: "Innovamos para ti",
		}
	};
	propData.seccion1.name = propData.name;
	propData.seccion8.text1 = propData.name;
	propData.seccion11.name = propData.name;

	return <InitClaro {...propData} />; // ✅ Solo renderizamos el componente
};
